<div class="share-popup">
    <div class="share-url">{{URL}}</div>
    <div class="share-buttons mt-3">
        <div class="d-flex flex-wrap align-items-center justify-content-center gap-2">
            <button type="button" class="btn btn-primary px-6" (click)="fnOpenEmail()">{{LANGUAGE==LANGUAGE_ENUM.EN?"Send email":"email senden"}}</button>
            <button type="button" class="btn btn-light px-6" (click)="fnCopyUrl()">{{LANGUAGE==LANGUAGE_ENUM.EN?"Copy URL":"URL kopieren"}}</button>
        </div>
    </div>
</div>
